import { useState } from "react";
import { FaCheckCircle, FaQuestionCircle, FaExclamationCircle } from "react-icons/fa";
import { HiOutlineLightningBolt } from "react-icons/hi";
import { addJiraComment, deleteJiraComment, updateJiraComment } from "../../services/api";
import { toast } from "react-hot-toast";
import { DataState } from "../../context/DataProvider";



function convertToIST(dateString) {
    // Parse the date string into a Date object (in UTC)
    const dateUTC = new Date(dateString);
  
    // Format the date to "28 Jan, 2025"
    const formattedDate = dateUTC.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  
    // Format the time to "7:20 AM"
    const formattedTime = dateUTC.toLocaleTimeString("en-IN", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  
    return { date: formattedDate, time: formattedTime };
}

const JiraIssueActivity = ({issue_key,comments,allAssignees,refreshIssue  }) => {
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [editedCommentBody, setEditedCommentBody] = useState("");
    const [activeTab, setActiveTab] = useState("Comments"); // Default to "Comments"
    const [textareaValue, setTextareaValue] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [savecommentloading, setSavecommentloading] = useState(false);
    const [deletecommentLoading, setDeletecommentLoading] = useState({});
    const [editcommentSaveLoading, setEditCommentSaveLoading] = useState({}); 
      const {
        userGoogleId
      } = DataState();




    const handleCommentEdit = (commentId, newBody) => {
        // console.log(`Edited comment ${commentId}: ${newBody}`);
        // Add logic to update the comment in state or send to backend
    };

    const handleEditCommentCancel = () => {
        // Reset the editing states to cancel editing
        setEditingCommentId(null);
        setEditedCommentBody("");
    };


    const startEditing = (comment) => {
        setEditingCommentId(comment.id);
        setEditedCommentBody(comment.body);
    };
    

    const handleTextareaChange = (e) => {
        setTextareaValue(e.target.value);
        setIsEditing(e.target.value.trim() !== ""); // Show buttons only when there is text
    };

    const handleButtonClick = (text) => {
        setTextareaValue(text);
        setIsEditing(true); // Show Save & Cancel when a button is clicked
    };

    const handleSaveComment = async () => {
        if (textareaValue.trim()) {
            setSavecommentloading(true);

            try {
                // const comment_data_body = {"comment_body":textareaValue.trim()};
                const commentData = {
                    body: {
                        type: "doc",
                        version: 1,
                        content: [
                            {
                                type: "paragraph",
                                content: [
                                    {
                                        text: textareaValue.trim(),
                                        type: "text"
                                    }
                                ]
                            }
                        ]
                    }
                };
            
    
                const response = await addJiraComment(issue_key, commentData,userGoogleId);

                toast.success("Comment saved successfully!");

                setTextareaValue("");
                setIsEditing(false);
                refreshIssue();
            } catch (error) {
                console.error("Error saving comment:", error);
            }
            finally {
                setSavecommentloading(false);  
            }
        }
    };

    const handleCommentDelete = async (commentId) => {
        setDeletecommentLoading((prevState) => ({
            ...prevState,
            [commentId]: true,  // Set loading state for the specific comment
        }));
    
    
        try {
            await deleteJiraComment(issue_key, commentId,userGoogleId);
    
            toast.success("Comment deleted successfully!");
    
            refreshIssue(); 
        } catch (error) {
            console.error("Error deleting comment:", error);
            toast.error("Failed to delete comment.");
        } finally {
            setDeletecommentLoading((prevState) => ({
                ...prevState,
                [commentId]: false,  // Reset loading state for the specific comment
            })); 
        }
    };
    
    const saveEditedComment = async (commentId) => {
        if (editedCommentBody.trim()) {
          setEditCommentSaveLoading((prevState) => ({
            ...prevState,
            [commentId]: true,
          }));
      
          try {
            await updateJiraComment(issue_key, commentId, editedCommentBody.trim(),userGoogleId);
      
            toast.success("Comment updated successfully!");
      
            setEditedCommentBody("");
            setEditingCommentId(null); 
            refreshIssue(); 
          } catch (error) {
            console.error("Error updating comment:", error);
            toast.error("Error updating comment!");
          } finally {
            setEditCommentSaveLoading((prevState) => ({
              ...prevState,
              [commentId]: false,
            }));
          }
        }
      };

    const handleCancelComment = () => {
        setTextareaValue("");
        setIsEditing(false);
    };

    return (
        <>
        <h3 className="font-semibold text-gray-800">Activity</h3>
        {/* Toggle Buttons */}
        <div className="flex mb-4 mt-2 p-1 space-x-1 border w-fit border-gray-300 rounded-md">
            {["All", "Comments", "History"].map((tab) => (
            <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-1 rounded-md text-xs font-medium transition-all 
                ${activeTab === tab ? "bg-blue-100 text-[#5652CF] border border-[#5652CF]" : " text-gray-700 border border-white hover:border-gray-200 hover:bg-gray-200"}
                `}
            >
                {tab}
            </button>
            ))}
        </div>

        <div>
            {activeTab === "All" && (
            <div>
                <h3 className="text-sm mb-2 font-semibold text-gray-700">All Activity</h3>
                <div className="comment-section rounded-lg">
                    {comments?.map((comment) => {
                        const author = allAssignees.find(user => user.accountId === comment.author.accountId);
                        const avatarUrl = author ? author.avatarUrls?.["16x16"] : null;
                        
                        return (
                        <div key={comment.id} className="comment flex mb-4 p-3 bg-white rounded-lg shadow-sm border border-gray-200">
                            {avatarUrl && (
                                <img src={avatarUrl} alt={`${comment.author.displayName}'s avatar`} className="w-8 h-8 rounded-full mr-3" />
                            )}
                            <div>
                            {/* Comment Header */}
                            <div className="comment-header flex items-center text-gray-700 font-semibold">
                            
                            {comment.author.displayName}
                            {/* <span className="text-gray-500 text-sm ml-2">• {convertToIST(comment.created).date} {convertToIST(comment.created).time}</span> */}
                            {(() => {
                                const commentDateTime = convertToIST(comment.created);
                                return (
                                    <span className="text-gray-500 text-sm ml-2">
                                        • {commentDateTime.date} {commentDateTime.time}
                                    </span>
                                );
                            })()}
                            </div>

                            {/* Editable Comment Body */}
                            <div className="comment-body text-gray-800 mt-2">
                            {editingCommentId === comment.id ? (
                                <textarea
                                className="w-full border border-gray-300 p-2 rounded-md text-gray-700"
                                value={editedCommentBody}
                                onChange={(e) => setEditedCommentBody(e.target.value)}
                                />
                            ) : (
                                <p>{comment.body}</p>
                            )}
                            </div>

                            
                            </div>
                        </div>
                        );
                    })}
                </div>
            </div>
            )}

            {activeTab === "Comments" && (
                <div>
                <div className="flex flex-col border border-gray-300 rounded-lg ">
                <textarea
                    id="textarea"
                    rows="5"
                    value={textareaValue}
                    onChange={handleTextareaChange}
                    placeholder="Write your comment here..."
                    className="w-full p-3 text-sm text-gray-800 rounded-lg focus:outline-none scrollbar-none focus:ring-1 focus:ring-gray-400 resize-none"
                ></textarea>
                {isEditing && (
                    <div className="flex justify-end items-center text-xs gap-2 p-1 mb-1 mt-1 ">
                        <button
                            className="px-3 py-1 bg-blue-600 text-white rounded-md  font-medium"
                            onClick={handleSaveComment}
                            disabled={savecommentloading}
                        >
                            {savecommentloading ? (
                                <span className="loader">Saving...</span>
                            ) : (
                                "Save"
                            )}
                        </button>
                        <button
                            className="px-3 py-1 bg-gray-400 text-white rounded-md font-medium"
                            onClick={handleCancelComment}
                        >
                            Cancel
                        </button>
                    </div>
                )}
                </div>


                <div className="flex items-center mt-2 mb-4 gap-2 flex-wrap">
                    <button
                        className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium flex items-center gap-1"
                        onClick={() => handleButtonClick("✔️ Looks good!")}
                    >
                        <FaCheckCircle /> Looks good!
                    </button>
                    <button
                        className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-xs font-medium flex items-center gap-1"
                        onClick={() => handleButtonClick("❓ Need help?")}
                    >
                        <FaQuestionCircle /> Need help?
                    </button>
                    <button
                        className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-medium flex items-center gap-1"
                        onClick={() => handleButtonClick("⚠️ This is blocked...")}
                    >
                        <FaExclamationCircle /> This is blocked...
                    </button>
                    <button
                        className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium flex items-center gap-1"
                        onClick={() => handleButtonClick("⚡ Can you clarify...?")}
                    >
                        <HiOutlineLightningBolt /> Can you clarify...?
                    </button>
                    <button
                        className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium flex items-center gap-1"
                        onClick={() => handleButtonClick("✔️ This is on track")}
                    >
                        <FaCheckCircle /> This is on track
                    </button>
                </div>

                
                <div className="comment-section rounded-lg">
                    {comments?.map((comment) => {
                        const author = allAssignees.find(user => user.accountId === comment.author.accountId);
                        const avatarUrl = author ? author.avatarUrls?.["16x16"] : null;
                        
                        return (
                        <div key={comment.id} className="comment flex mb-4 p-3 bg-white rounded-lg shadow-sm border border-gray-200">
                            {avatarUrl && (
                                <img src={avatarUrl} alt={`${comment.author.displayName}'s avatar`} className="w-8 h-8 rounded-full mr-3" />
                            )}
                            <div>
                            {/* Comment Header */}
                            <div className="comment-header flex items-center text-gray-700 font-semibold">
                            
                            {comment.author.displayName}
                            {/* <span className="text-gray-500 text-sm ml-2">• {convertToIST(comment.created).date} {convertToIST(comment.created).time}</span> */}
                            {(() => {
                                const commentDateTime = convertToIST(comment.created);
                                return (
                                    <span className="text-gray-500 text-sm ml-2">
                                        • {commentDateTime.date} {commentDateTime.time}
                                    </span>
                                );
                            })()}
                            </div>

                            {/* Editable Comment Body */}
                            <div className="comment-body text-gray-800 mt-2">
                            {editingCommentId === comment.id ? (
                                <textarea
                                className="w-full border border-gray-300 p-2 rounded-md scrollbar-none text-gray-700 focus:outline-none focus:ring-1 "
                                value={editedCommentBody}
                                onChange={(e) => setEditedCommentBody(e.target.value)}
                                />
                            ) : (
                                <p>{comment.body}</p>
                            )}
                            </div>

                            {/* Action Buttons */}
                            <div className="mt-2 flex items-center space-x-2">
                            {editingCommentId === comment.id ? (
                                <>
                                <button
                                onClick={() => saveEditedComment(comment.id)}
                                className="  text-gray-400 text-sm hover:underline hover:text-gray-700"
                                disabled={editcommentSaveLoading[comment.id]}
                                >
                                    {editcommentSaveLoading[comment.id] ? (
                                    <span className="loader">Saving...</span> // Show loader if saving
                                    ) : (
                                    "• Save"
                                    )}
                                </button>
                                <button
                                onClick={() => handleEditCommentCancel()}
                                className=" text-gray-400 text-sm hover:underline hover:text-gray-700"
                               >
                                • cancel
                                </button>
                                </>
                            ) : (
                                <>
                                <button
                                onClick={() => startEditing(comment)}
                                className=" text-gray-400 text-sm hover:underline hover:text-gray-700"
                                >
                                • Edit
                                </button>
                                <button
                                    onClick={() => handleCommentDelete(comment.id)}
                                    className=" text-gray-400 text-sm hover:underline hover:text-gray-700"
                                    disabled={deletecommentLoading[comment.id]}
                                >
                                    {deletecommentLoading[comment.id] ? (
                                        <span className="loader">Deleting...</span> 
                                    ) : (
                                        "• Delete"
                                    )}
                                </button>
                                </>
                            )}
                            </div>
                            </div>
                        </div>
                        );
                    })}
                </div>
                </div>
            )}

            {activeTab === "History" && (
            <div>
                <h3 className="text-sm font-semibold text-gray-700">History</h3>
                <ul className="text-gray-600">
               
                    <p>No history available.</p>
                
                </ul>
            </div>
            )}

        </div>
        </>
  );
};

export default JiraIssueActivity;